/**
 * @generated SignedSource<<5ae6968ebb546a92ea4f28acfd500a02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MembersAppSettingsButtonFragment$data = {
  readonly id: string;
  readonly kind: ProductAppKind;
  readonly productId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"MemberDirectoryAppSettingsModalFragment">;
  readonly " $fragmentType": "MembersAppSettingsButtonFragment";
};
export type MembersAppSettingsButtonFragment$key = {
  readonly " $data"?: MembersAppSettingsButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MembersAppSettingsButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MembersAppSettingsButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MemberDirectoryAppSettingsModalFragment"
    }
  ],
  "type": "ProductApp",
  "abstractKey": null
};

(node as any).hash = "bdee9a6f544917d12a6737077cb0dbba";

export default node;
